// These are ported from ScoroConstants/Modules package
// Please keep these files synced if making changes

import { TYPES, ContactType } from '@/generated/graphql';

export const Module = {
	ADDITIONAL_ACCOUNTS: {
		name: 'additional_accounts',
		icon: 'building',
		typename: undefined,
		url: undefined,
		color: undefined,
	},
	BUDGETS: {
		name: 'budgets',
		icon: 'budget',
		typename: undefined,
		url: undefined,
		color: undefined,
	},
	BOOKINGS: {
		name: 'bookings',
		icon: undefined,
		typename: undefined,
		url: 'bookings',
		color: undefined,
	},
	CALENDAR: {
		name: 'calendar',
		icon: 'calendar',
		typename: TYPES.CalendarEvent,
		url: 'calendar',
		color: '#ef8498',
	},
	COMPANIES: {
		name: 'companies',
		icon: 'building',
		typename: ContactType.Company,
		url: 'companies',
		color: '#bf9dee',
	},
	CONTACTS: {
		name: 'contacts',
		icon: 'person',
		typename: TYPES.Contact,
		url: 'contacts',
		color: '#bf9dee',
	},
	DOCS: {
		name: 'docs',
		icon: 'paper',
		typename: undefined,
		url: undefined,
		color: undefined,
	},
	PURCHASES: {
		name: 'purchases',
		icon: 'paper-in',
		typename: undefined,
		url: undefined,
		color: undefined,
	},
	BILLS: {
		name: 'bills',
		icon: 'paper-out',
		typename: TYPES.Bill,
		url: 'bills',
		color: '#85ce77',
	},
	PURCHASE_ORDERS: {
		name: 'purchaseOrders',
		icon: 'paper-in',
		typename: TYPES.PurchaseOrder,
		url: 'purchaseOrders',
		color: '#85ce77',
	},
	FILES: {
		name: 'files',
		icon: 'paperclip',
		typename: TYPES.File,
		url: 'files',
		color: undefined,
	},
	IMPORT_EXPORT: {
		name: 'importExport',
		icon: 'download',
		typename: TYPES.ImportType,
		url: 'importExport',
		color: undefined,
	},
	INTRA: {
		name: 'intra',
		icon: 'list',
		typename: TYPES.NewsFeedItem,
		url: 'intra',
		color: undefined,
	},
	INVOICES: {
		name: 'invoices',
		icon: 'paper-coins',
		typename: TYPES.Invoice,
		url: 'invoices',
		color: '#85ce77',
	},
	RECEIPTS: {
		name: 'receipts',
		icon: 'paper-out',
		typename: undefined,
		url: undefined,
		color: '#85ce77',
	},
	PREPAYMENTS: {
		name: 'prepayments',
		icon: 'paper-coins',
		typename: TYPES.Prepayment,
		url: 'invoices/prepayments',
		color: '#85ce77',
	},
	LOGIN: {
		name: 'login',
		icon: 'lock-closed',
		typename: undefined,
		url: undefined,
		color: undefined,
	},
	MAIN: {
		name: 'main',
		icon: 'dashboard',
		typename: undefined,
		url: 'main',
		color: undefined,
	},
	MARKETING: {
		name: 'marketing',
		icon: 'megaphone',
		typename: TYPES.MarketingList,
		url: 'marketing',
		color: undefined,
	},
	NEXT_ADMIN: {
		name: 'next_admin',
		icon: 'view',
		typename: undefined,
		url: undefined,
		color: undefined,
	},
	NEWS: {
		name: 'news',
		icon: 'list',
		typename: undefined,
		url: undefined,
		color: undefined,
	},
	QUOTES: {
		name: 'quotes',
		icon: 'paper-out',
		typename: TYPES.Quote,
		url: 'quotes',
		color: '#85ce77',
	},
	ORDERS: {
		name: 'orders',
		icon: 'paper-in',
		typename: TYPES.Order,
		url: 'orders',
		color: '#85ce77',
	},
	PERSONS: {
		name: 'persons',
		icon: 'person',
		typename: ContactType.Person,
		url: 'persons',
		color: '#bf9dee',
	},
	PIPELINE: {
		name: 'pipeline',
		icon: 'board',
		typename: undefined,
		url: 'pipeline',
		color: undefined,
	},
	PRODUCTS: {
		name: 'products',
		icon: 'box',
		typename: undefined,
		url: undefined,
		color: undefined,
	},
	PROJECTS: {
		name: 'projects',
		icon: 'briefcase',
		typename: TYPES.Project,
		url: 'projects',
		color: '#5ab2ed',
	},
	PLANNER: {
		name: 'planningMode',
		icon: 'planner',
		typename: undefined,
		url: 'planningMode',
		color: undefined,
	},
	PURCHASE_REQUESTS: {
		name: 'purchaseRequests',
		icon: 'paper-in',
		typename: undefined,
		url: undefined,
		color: '#85ce77',
	},
	QUOTA: {
		name: 'quota',
		icon: undefined,
		typename: undefined,
		url: undefined,
		color: undefined,
	},
	REALESTATE: {
		name: 'realEstate',
		icon: 'house',
		typename: TYPES.RealEstateObject,
		url: undefined,
		color: undefined,
	},
	RENTAL_ORDERS: {
		name: 'rentalOrders',
		icon: 'paper-in',
		typename: TYPES.RentalOrder,
		url: undefined,
		color: '#85ce77',
	},
	REPORTS: {
		name: 'reports',
		icon: 'graph',
		typename: undefined,
		url: 'reports',
		color: undefined,
	},
	SETTINGS: {
		name: 'settings',
		icon: 'sprocket',
		typename: undefined,
		url: 'settings',
		color: undefined,
	},
	TASKS: {
		name: 'tasks',
		icon: 'task',
		typename: TYPES.Task,
		url: 'tasks',
		color: '#5ab2ed',
	},
	TIME_ENTRIES: {
		name: 'timeEntry',
		icon: 'clock',
		typename: TYPES.TimeEntry,
		url: 'tasks',
		color: '#5ab2ed',
	},
	EVENTS: {
		name: 'events',
		icon: 'calendar',
		typename: TYPES.CalendarEvent,
		url: 'calendar',
		color: '#ef8498',
	},
	COMMENTS: {
		name: 'comments',
		icon: 'chat',
		typename: TYPES.Comment,
		url: undefined,
		color: '#b3bcf5',
	},
	APPRAISALS: {
		name: 'appraisals',
		icon: 'paper-coins',
		typename: undefined,
		url: undefined,
		color: undefined,
	},
	TERMS_OF_SERVICE: {
		name: 'tos',
		icon: 'paper',
		typename: undefined,
		url: undefined,
		color: undefined,
	},
	PRIVACY_POLICY: {
		name: 'privacy',
		icon: 'paper',
		typename: undefined,
		url: undefined,
		color: undefined,
	},
	TERMS: {
		name: 'terms',
		icon: 'paper',
		typename: undefined,
		url: undefined,
		color: undefined,
	},
	CUSTOM: {
		name: 'custom',
		icon: undefined,
		typename: TYPES.CustomModuleEntry,
		url: undefined,
		color: undefined,
	},
	USERS: {
		name: 'users',
		icon: 'person',
		typename: TYPES.User,
		url: 'settings/users',
		color: undefined,
	},
	EXPENSES: {
		name: 'expenses',
		icon: 'paper-in',
		typename: TYPES.Expense,
		url: 'expenses',
		color: '#85ce77',
	},
	CUSTOMER_PORTAL: {
		name: 'customer_portal',
		icon: 'external',
		typename: undefined,
		url: 'settings/customerPortal/users',
		color: undefined,
	},
	BACKGROUND_JOBS: {
		name: 'backgroundJobs',
		icon: undefined,
		typename: TYPES.BackgroundJob,
		url: 'settings/backgroundJobs',
		color: undefined,
	},
	PACKAGE: {
		name: 'package',
		icon: undefined,
		typename: undefined,
		url: 'settings/package',
		color: undefined,
	},
	EXPORT_DATA: {
		name: 'exportData',
		icon: undefined,
		typename: undefined,
		url: undefined,
		color: undefined,
	},
	WELCOME: {
		name: 'welcome',
		icon: undefined,
		typename: undefined,
		url: undefined,
		color: undefined,
	},
} as const;
